module.exports = __webpack_public_path__ + "img/white-paper-purple.3b33e188.svg";